import * as T from '@radix-ui/react-tabs';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils.ts';

export const Tabs = T.Root;
/** Segmented control (filters inside a page) — visually distinct from the top menu. */
export const TabsList = ({ className, ...p }: ComponentProps<typeof T.List>) => (
  <T.List
    className={cn('inline-flex flex-wrap gap-1 rounded-[14px] bg-fill p-1', className)}
    {...p}
  />
);
export const TabsTrigger = ({ className, ...p }: ComponentProps<typeof T.Trigger>) => (
  <T.Trigger
    className={cn(
      'rounded-[10px] px-3 py-1.5 text-[14px] font-medium text-muted transition data-[state=active]:bg-card data-[state=active]:text-fg data-[state=active]:shadow-sm',
      className,
    )}
    {...p}
  />
);
export const TabsContent = T.Content;
